import { CurrencyValue, LineChart } from '@blockanalitica/ui';
import {
  SimpleChartData,
  SimpleChartDataset
} from '@blockanalitica/ui/package/types/src/components/charts/SimpleChart';
import { useCallback, useMemo } from 'react';
import { useChartFillDatasetsDates } from '@/hooks';

export default function OverviewGraphs({
  data,
  type,
  chartDaysAgo
}: {
  data: SimpleChartData[];
  type: string;
  chartDaysAgo: string;
}) {
  const [datasets] = useMemo(() => {
    const datasets: SimpleChartDataset[] = [
      {
        xField: 'date',
        yField: type
      }
    ];
    const chartType: string = 'line';

    return [datasets, chartType];
  }, [type]);

  const valueFormatter = useCallback((value: string | number) => {
    return (
      <CurrencyValue
        value={value}
        options={{
          currency: 'USD',
          notation: 'compact'
        }}
      />
    );
  }, []);

  const chartData = useChartFillDatasetsDates(data, datasets, chartDaysAgo);

  return (
    <LineChart
      key={type}
      data={chartData}
      datasets={datasets}
      valueFormatter={valueFormatter}
      daysAgo={chartDaysAgo}
    />
  );
}
